import React from 'react'

export default function ServicesPage() {
  return (
    <div className='services-container'>
      <div className='services-text'>
      
      <h1>Szolgáltatások</h1>

      <h2>Épület körüli szimulációk:</h2>
      <p>

      <ul>

      <li>Épületen belüli szélszívás modellezése</li>
      <li>Épület körüli áramlások modellezése</li>
      <li>Gyalogoskomfort modellezése</li>

      </ul>

      </p>

      <h2>Épületen belüli szimulációk:</h2>

      <p>

      <ul>
        <li>Hőrétegződés modellezése</li>
        <li>Hőkomfort modellezése (PMV, PPD, DR)</li>
        <li>Szellőzés hatékonyságának kimutatása (Age of Air vizsgálat)</li>
        <li>Szellőzés hő és áramlástani szimulációja</li>
      </ul>

      </p>



      </div>
    </div>
  )
}
